import { useTranslation } from "react-i18next";

/**
 * Small AI disclaimer rendered directly under the chat composer (web).
 * Same place ChatGPT / Gemini / Claude show theirs. Inter, 11–12px,
 * neutral-400. Not dismissible.
 */
export default function AiDisclaimer({ className = "" }) {
    const { t } = useTranslation();
    return (
        <p
            className={`mt-2.5 text-center text-[11.5px] text-[#9CA3AF] ${className}`}
            style={{ fontFamily: "Inter, sans-serif", letterSpacing: 0 }}
            data-testid="ai-disclaimer"
        >
            {t("chat.ai_disclaimer")}
        </p>
    );
}
